// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getNotifyStyle } from "@flip/App/Components/Notify";
import { xScreen } from "@flip/XDL/Utilities";
import { rfqMyQuotesTableStyles } from "@insite/content-library/Widgets/RfqMyQuotes/RfqMyQuotesTable";
import { css } from "styled-components";

rfqMyQuotesTableStyles.quoteNumberHeader = {
    tight: true,
};

rfqMyQuotesTableStyles.noResultsContainer = {};

rfqMyQuotesTableStyles.noResultsText = {
    ...getNotifyStyle("warning"),
};

// XNG-Changes
rfqMyQuotesTableStyles.quoteLink = {
    typographyProps: {
        css: css`
            ${xScreen("lte", "sm")} {
                font-size: 14px;
            }
        `,
    },
};
